import { formatDate, formatDateTime, parseDate } from "@patterns/core";
var FormGlobal = /** @class */ (function () {
    function FormGlobal() {
    }
    FormGlobal.formatDate = function (date) { return formatDate(date); };
    FormGlobal.formatDateTime = function (date) { return formatDateTime(date); };
    FormGlobal.parseDate = function (date) { return parseDate(date); };
    FormGlobal.token = '';
    return FormGlobal;
}());
export { FormGlobal };
//# sourceMappingURL=form-global.js.map